var orderBy = require('./orderBy')

var sortBy = orderBy

module.exports = sortBy



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.5.27/~/xe-utils/sortBy.js
// module id = 1082
// module chunks = 75